import React, { useEffect, useState } from 'react';

import { ApiPortfolioState } from '../../dashboard/models/ApiPortfolioState';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CommentComponent from './CommentComponent';
import { CommentModel } from '../models/CommentModel';
import { CustomLoadingProgress } from '../../shared/components/CustomLoadingProgress';
import Grid from '@mui/material/Unstable_Grid2';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import styles from '../styles/CommentComponent.module.css';
import useComments from '../hooks/useComments';
import { useLessonPlayerContext } from '../../dashboard/models/LessonPlayerContext';
import { useLessonPlayerMarkingContext } from '../models/LessonPlayerMarkingContext';

interface CommentPanelProps {
  marker: string;
}

export default function CommentPanel(props: CommentPanelProps) {
  const { lessonState } = useLessonPlayerContext();
  const { assignedToMe } = useLessonPlayerMarkingContext();

  const answerParams = lessonState?.answerParams;

  const [comment, setComment] = useState('');

  const {
    loading,
    comments,
    adding,
    addError,
    addCommentData,
    addComment,
    updateComment
  } = useComments(
    answerParams?.userkey,
    answerParams?.lessonkey,
    answerParams?.layer
  );

  useEffect(() => {
    if (addCommentData) {
      setComment('');
    }
  }, [addCommentData]);

  function handleAddComment() {
    addComment(comment);
  }

  function handleEdit(comment: CommentModel, updatedText: string) {
    updateComment(comment.discussionkey, comment.commentkey, updatedText);
  }

  function handleDelete(comment: CommentModel) {
    updateComment(
      comment.discussionkey,
      comment.commentkey,
      comment.assets.text,
      false //'active' should be false for soft delete comment
    );
  }

  return (
    <>
      <Box className={styles.root}>
        <Grid
          container
          className={styles.commentsBox}
          direction="column"
          justifyContent="space-between"
        >
          <Grid
            className={styles.comments}
            direction="column"
            container
            justifyContent={
              loading || (comments && comments.length === 0)
                ? 'center'
                : 'flex-start'
            }
          >
            {loading ? (
              <Grid container justifyContent="center" alignItems="center">
                <CustomLoadingProgress size={20} />
              </Grid>
            ) : comments && comments.length > 0 ? (
              comments.map((comment) => (
                <Grid key={comment.commentkey} className={styles.comment}>
                  <CommentComponent
                    {...props}
                    comment={comment}
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                  />
                </Grid>
              ))
            ) : (
              <Grid>
                <Typography align="center" className={styles.noComments}>
                  Looks like there aren't any comments here.
                </Typography>
              </Grid>
            )}
          </Grid>
          {assignedToMe &&
            lessonState.state === ApiPortfolioState.AssessmentMark && (
              <Grid
                container
                xs={12}
                direction="column"
                className={styles.inputBox}
              >
                <TextField
                  placeholder="Add a comment"
                  variant="outlined"
                  multiline
                  className={styles.input}
                  minRows={3}
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
                <Button
                  size="small"
                  className={styles.addBtn}
                  onClick={handleAddComment}
                  disabled={adding || !comment}
                >
                  Add
                </Button>
              </Grid>
            )}
        </Grid>
      </Box>
    </>
  );
}
